import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, styled, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import { getPaymentMethodsBySite } from '@shared/services/services';
import Skeleton from '@mui/material/Skeleton';

import moment from 'moment';

import { sxStyled } from './styles';

const BodyContainer = styled('div')(({ theme }) => ({
  backgroundColor: '#F6F6F6',
  [theme.breakpoints.down('md')]: {
    padding: 20,
  },
}));

export default () => {
  const { id } = useSelector(store => store.pageConfiguration);

  const theme = useTheme();
  const sxStyle = sxStyled(theme);

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchContactUs();
  }, []);

  const fetchContactUs = async () => {
    getPaymentMethodsBySite(id)
      .then(res => {
        setData(res);
        setLoading(false);
      })
      .catch(err => console.error('error', err));
  };

  const renderProgramasSection = (title, programas, card) => {
    if (!programas?.length) return null;

    return (
      <>
        <Typography component="p" sx={sxStyle.subInformacionTarjetas}>
          {title}
        </Typography>
        <ul>
          {programas.map(programa => {
            const hasInstallments = programa?.card_installments?.length;
            if (!hasInstallments) return null;

            const { installments, value } = programa.card_installments[0];
            const label = installments.name + ': ';
            const display = value === 0 ? 'Sin interés' : `${value}%`;

            return (
              <Typography component="li" key={programa.id}>
                {card.type === 'Crédito' ? label : null}
                {display}
              </Typography>
            );
          })}
        </ul>
      </>
    );
  };

  return (
    <BodyContainer>
      {loading ? (
        <Grid container direction="column" style={{ padding: '40px 80px' }}>
          <Grid container direction="column">
            <Skeleton
              variant="text"
              height={50}
              width="20%"
              style={{ marginBottom: '20px' }}
            />
            <Skeleton
              variant="text"
              height={50}
              width="20%"
              style={{ marginBottom: '30px' }}
            />

            <Grid container direction="row" spacing={2}>
              {[...Array(4)].map((_, index) => (
                <Grid item xs={3} key={index}>
                  <Skeleton variant="text" height={80} width="50%" />
                  <Skeleton variant="text" height={30} width="80%" />
                  <Skeleton variant="text" height={30} width="80%" />
                  <Skeleton variant="text" height={30} width="80%" />
                  <Skeleton variant="text" height={30} width="80%" />
                  <Skeleton variant="text" height={30} width="80%" />
                  <Skeleton variant="text" height={30} width="80%" />
                </Grid>
              ))}
            </Grid>

            <div style={{ marginTop: '30px' }}>
              <Skeleton
                variant="text"
                height={40}
                width="10%"
                style={{ marginBottom: '20px' }}
              />
              <Skeleton variant="text" height={30} width="50%" />
              <Skeleton
                variant="text"
                height={30}
                width="50%"
                style={{ marginBottom: '20px' }}
              />
              <Skeleton variant="text" height={30} width="80%" />
            </div>

            <Grid container direction="column">
              <Skeleton
                variant="rect"
                width="100%"
                height={520}
                style={{ marginTop: '10px' }}
              />
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid container direction="column">
          <Grid
            container
            direction="column"
            sx={sxStyle.contenedorCuentasBancarias}
          >
            <Grid container direction="row" sx={sxStyle.title}>
              <Typography variant="h4" style={{ color: 'black' }}>
                Formas de pago
              </Typography>
            </Grid>
            {data?.bank_accounts.length ? (
              <>
                {' '}
                <Grid container direction="row" sx={sxStyle.subTitleContainer}>
                  <Typography variant="h5" sx={sxStyle.subTitle}>
                    Cuentas Bancarias
                  </Typography>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={sxStyle.contenedorBancos}
                  spacing={1}
                >
                  {data.bank_accounts.map(bank => (
                    <Grid
                      item
                      container
                      direction="column"
                      style={{ width: 'auto' }}
                      sx={sxStyle.cuentasBancarias}
                      xs={12}
                      md={3}
                      key={bank.id}
                    >
                      <Grid sx={sxStyle.miniContenedor}>
                        <Grid>
                          <Box
                            component="img"
                            sx={sxStyle.iconos}
                            src={bank?.logo}
                          />
                        </Grid>
                        <Typography variant="h5" sx={sxStyle.cardTitle}>
                          {bank?.bank_name}
                        </Typography>
                        {bank?.branch && (
                          <Typography component="p">
                            Sucursal: {bank.branch}
                          </Typography>
                        )}
                        {bank?.account_number && (
                          <Typography component="p">
                            CC en {bank.currency} Nº: {bank.account_number}
                          </Typography>
                        )}
                        {bank?.holder && (
                          <Typography component="p">
                            A nombre de: {bank.holder}
                          </Typography>
                        )}
                        {bank?.cuit && (
                          <Typography component="p">
                            CUIT: {bank.cuit}
                          </Typography>
                        )}
                        {bank?.cbu && (
                          <Typography component="p">CBU: {bank.cbu}</Typography>
                        )}
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </>
            ) : null}

            <Grid
              container
              direction="column"
              sx={sxStyle.contenedorAclaraciones}
            >
              <Typography variant="h5" style={{ color: 'black' }}>
                Aclaración:
              </Typography>
              <ul>
                <Typography component="li">
                  Las cuentas bancarias mencionadas son de uso exclusivo para
                  agencias de viajes.
                </Typography>
                <Typography component="li">
                  Una vez realizado el pago por este medio, envíe el comprobante
                  vía mail a:{' '}
                  <Typography
                    component="a"
                    href={`mailto:${
                      data?.receipt_email
                    }?subject=${encodeURIComponent('Comprobante vía Mail')}`}
                    target="_top"
                  >
                    <strong>{data?.receipt_email}</strong>
                  </Typography>
                </Typography>
              </ul>
              <Typography component="p" style={{ color: 'black' }}>
                Para pagos destinados a reservas en dólares, el tipo de cambio a
                aplicar será el del momento en el que comuniquen, mediante envío
                de comprobante, el pago en cuestión.
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            direction="column"
            sx={sxStyle.contenedorTarjetasDeCredito}
          >
            {data?.cards
              .sort((a, b) => {
                if (a.type === 'Crédito' && b.type !== 'Crédito') return -1;
                if (a.type !== 'Crédito' && b.type === 'Crédito') return 1;
                return 0;
              })
              .map(card => (
                <React.Fragment key={card.type}>
                  <Grid container sx={sxStyle.subTitleContainer}>
                    <Typography variant="h5" sx={sxStyle.subTitle}>
                      Tarjetas de {card.type}
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    direction="row"
                    sx={sxStyle.contenedorTarjetas}
                    spacing={2}
                  >
                    {card.items.map(item => {
                      const programasN = item.card_programs
                        .filter(
                          p =>
                            p.card_program_types.name === 'PROGRAMAS NACIONALES'
                        )
                        .sort((a, b) => a.order - b.order);

                      const programasNEI = item.card_programs
                        .filter(
                          p =>
                            p.card_program_types.name ===
                            'PROGRAMAS NACIONALES E INTERNACIONALES'
                        )
                        .sort((a, b) => a.order - b.order);

                      return (
                        <Grid
                          item
                          container
                          direction="column"
                          sx={sxStyle.cuentasBancarias}
                          xs={12}
                          md={3}
                          key={item.id}
                        >
                          <Grid sx={sxStyle.miniContenedor}>
                            <Grid>
                              <Box
                                component="img"
                                sx={sxStyle.iconos}
                                src={item?.logo}
                              />
                            </Grid>
                            <Typography variant="h5" sx={sxStyle.cardTitle}>
                              {item.name}
                            </Typography>
                            <Typography component="p">
                              Vigencia hasta{' '}
                              {moment(item?.expiration_date).format(
                                'DD/MM/YYYY'
                              )}
                            </Typography>
                            {item?.merchant_number && (
                              <Typography component="p">
                                Número de comercio: {item.merchant_number}
                              </Typography>
                            )}
                            {item?.phone && (
                              <Typography component="p">
                                Teléfono: {item.phone}{' '}
                                {item?.extra_phone
                                  ? '/ ' + item?.extra_phone
                                  : ''}
                              </Typography>
                            )}
                            {item.card_programs.length > 0 && (
                              <Typography component="p">
                                Sumar al monto a financiar el gasto de gestión:
                              </Typography>
                            )}
                            <div style={{ marginTop: '20px' }}></div>
                            {item.card_programs.length ? (
                              <>
                                {renderProgramasSection(
                                  'PROGRAMAS NACIONALES E INTERNACIONALES',
                                  programasNEI,
                                  card
                                )}
                                {renderProgramasSection(
                                  'PROGRAMAS NACIONALES',
                                  programasN,
                                  card
                                )}
                              </>
                            ) : (
                              <Typography
                                component="p"
                                sx={sxStyle.subInformacionTarjetas}
                              >
                                SUSPENDIDA MOMENTÁNEAMENTE
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                      );
                    })}
                  </Grid>
                </React.Fragment>
              ))}

            <Grid
              container
              direction="column"
              sx={sxStyle.contenedorInformacionImportante}
            >
              <Grid
                container
                direction="row"
                sx={sxStyle.contenedorSubtituloInformacionImportante}
              >
                <Typography variant="h5" sx={sxStyle.subTitle}>
                  Información Importante
                </Typography>
              </Grid>
              <Typography component="p">
                <strong>Vigencia:</strong> Las cuentas bancarias mencionadas son
                de uso exclusivo para agencias de viajes.
              </Typography>
              <Typography component="p">
                <strong>Modalidad:</strong> El pago se realiza desde la web,
                ingresando con tu usuario y contraseña - Opción Pago
                Electrónico.
              </Typography>
              <Typography component="p">
                <strong>
                  Todos aquellos planes de financiación que no se encuentren
                  detallados con su costo respectivo, por favor contactarse con
                  la Administración para mayor información.
                </strong>
              </Typography>
            </Grid>
          </Grid>

          {data?.cccf_auth_url ? (
            <Grid
              container
              direction="column"
              sx={sxStyle.contenedorCartaAutorizacion}
            >
              <Grid
                container
                direction="row"
                sx={sxStyle.contenedorSubTituloCartaAutorizacion}
              >
                <Typography variant="h5" sx={sxStyle.subTitle}>
                  Carta de autorización para CCCF
                </Typography>
              </Grid>
              <Typography component="p">
                Carta de autorización para CCCF (consulte financiacion de cada
                aerolínea).
              </Typography>

              <Grid container direction="row" sx={sxStyle.contenedorDescarga}>
                <Box
                  component="a"
                  sx={sxStyle.contenedorLink}
                  title="Descargar PDF"
                  href={data.cccf_auth_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Box
                    component="i"
                    className="material-icons"
                    sx={sxStyle.materialUiIcon}
                  >
                    content_paste
                  </Box>

                  <Typography component="p">
                    <strong>Descargar Carta de autorización</strong>
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          ) : null}
        </Grid>
      )}
    </BodyContainer>
  );
};
